/**
 * Repository for the app's Layout state
 */
export default {
  state: {
    /** @var String */
    layout: ''
  },
  getters: {
    layout: state => {
      return state.layout
    }
  },
  mutations: {
    setLayout (state, layout) {
      state.layout = layout
    }
  },
  actions: {
    setLayout (context, layout) {
      context.commit('setLayout', layout)
    }
  }
}
